export default "/assets/images/rookie-parent-crop.df574a3ee0e97276.webp";